// Utils
import { getEditorType } from '../editorTypeUtils';
import { reduceImTiptapContent } from './reduceImTiptapContent';

// Types
import { EditorContent, ImEditorContent } from '../../../elements/elementModelTypes';
import { ElementEditor } from '../../../elements/elementEditorConstants';
import { TiptapContent, TiptapContentNode, TiptapMarkType } from '../../tiptapTypes';
import { asObject, ImMap, isEmpty, prop } from '../../../utils/immutableHelper';

/**
 * Retrieves inline comment thread IDs by recursing through Tiptap nodes and finding inlineComment marks
 */
const getTiptapEditorJsonInlineCommentIds = (content: ImMap<TiptapContent> | TiptapContent): string[] =>
    reduceImTiptapContent(
        content,
        (commentThreadIds, tiptapNode) => {
            const imMarks = prop('marks', tiptapNode);

            if (isEmpty(imMarks)) return commentThreadIds;

            const marks = asObject<TiptapContentNode['marks']>(imMarks);

            marks?.forEach((mark) => {
                if (mark.type !== TiptapMarkType.inlineComment) return;

                const id = mark.attrs?.commentThreadId;
                if (id) commentThreadIds.push(id);
            });

            return commentThreadIds;
        },
        [] as string[],
    );

/**
 * Retrieves an array of all the inline comment thread IDs within the provided content.
 * Returns an empty array if the editor content is not Tiptap content.
 */
const getEditorJsonInlineCommentIds = (content: ImEditorContent | EditorContent | string | undefined): string[] => {
    const editorType = getEditorType(content);
    if (editorType !== ElementEditor.Tiptap) return [];

    return getTiptapEditorJsonInlineCommentIds(content as ImMap<TiptapContent>);
};

export default getEditorJsonInlineCommentIds;
